const filters = [
  {
    name: 'accountNumber',
    validationType: '',
    func: value => {
      if (!value) {
        return;
      }

      return value.replace(/(.{4})(.{2}x{2})(x{4})(\d{4})/i, '$1 $3 $3 $4').replace(/x/gi, '*');
    },
  },
  {
    name: 'accountNumberShortMobile',
    validationType: '',
    func: value => {
      if (!value) {
        return;
      }

      return `**** ${value.slice(-4)}`;
    },
  },
  {
    name: 'accountNumberShort',
    validationType: '',
    func: value => {
      if (!value) {
        return;
      }

      return value.replace(/(.{4})(.{2}x{2})(x{4})(\d{4})/i, '$3 $4').replace(/x/gi, '*');
    },
  },
  {
    name: 'accountNumberShown',
    validationType: 'pan',
    func: value => {
      if (!value) {
        return;
      }

      const cardCode = value.replace(/[^\d]/g, '');

      return cardCode !== '' ? cardCode.match(/.{1,4}/g).join(' ') : '';
    },
  },
  {
    name: 'orderType',
    validationType: '',
    // eslint-disable-next-line complexity
    func: value => {
      switch (value) {
        case 'PAYOUT':
          return 'Вывод';
        case 'PURCHASE':
          return 'Перевод';
        case 'PURCHASE_BILL':
          return 'Перевод';
        case 'PARTNER_PAYOUT_ACCRUAL':
          return 'Перевод';
        case 'BILL':
          return 'Счёт';
        case 'MULTIBILL':
          return 'Мультисчёт';
        case 'SUBSCRIPTION':
          return 'Счёт-подписка';
        case 'TARIFF':
          return 'Счёт-тариф';
        case 'REFUND':
          return 'Возврат';
        case 'CONFIRM_CARD':
          return 'Привязка карты';
        case 'REFUND_DEBIT':
          return 'Пополнение баланса с целью возврата';
        case 'SERVICE_DEBIT_MERCHANT':
          return 'Сервисные списания';
        default:
          return value;
      }
    },
  },
  {
    name: 'sliceUrl',
    func: value => {
      if (!value) {
        return;
      }

      let index = value.indexOf('.') + 1;

      return `..${value.slice(index)}`;
    },
  },
  {
    name: 'lower',
    func: value => value.toLowerCase(),
  },
];

const computedFilters = [
  {
    name: 'getFilter',
    func: (value, filterName) => {
      let f = filters.find(el => el.validationType === filterName);

      return f && f.func(value);
    },
  },
];

export default filters.concat(computedFilters);
